import { Box, styled } from "@mui/material";

const MAIN_GUTTER_PX = 40;
const MAIN_GUTTER_MD_PX = 20;

/** Shell does not scroll — only the main outlet scrolls so the header stays put. */
export const StyledLayout = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
  background:
    "linear-gradient(to bottom, #ff8000 -30%, #FFA54D, #FFBE7E, #FFDAB9, #fff 16%)",
}));

/** Row under the top offset; no right padding so the main column (and outlet scrollbar) can reach the viewport edge. */
export const StyledLayoutContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  minHeight: 0,
  overflow: "hidden",
  boxSizing: "border-box",
  paddingTop: "21px",
  gap: "27px",
  [theme.breakpoints.down("md")]: {
    paddingLeft: "20px",
  },
}));

/** Right gutter for the navbar; outlet breaks out with matching negative margin so the scrollbar stays flush. */
export const StyledNavbar = styled(Box)(({ theme }) => ({
  width: "100%",
  flex: "1 1 auto",
  minHeight: 0,
  marginTop: "0px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  minWidth: "65%",
  boxSizing: "border-box",
  paddingRight: `${MAIN_GUTTER_PX}px`,
  [theme.breakpoints.down("md")]: {
    marginTop: "50px",
    width: "100%",
    paddingRight: `${MAIN_GUTTER_MD_PX}px`,
  },
}));

/** Scrolls under the fixed header; negative margin + padding keeps gutter without inset scrollbar. */
export const StyledBoxOutlet = styled(Box)(({ theme }) => ({
  flex: "1 1 auto",
  minHeight: 0,
  overflow: "auto",
  marginRight: `-${MAIN_GUTTER_PX}px`,
  paddingRight: `${MAIN_GUTTER_PX}px`,
  boxSizing: "border-box",
  [theme.breakpoints.down("md")]: {
    marginRight: `-${MAIN_GUTTER_MD_PX}px`,
    paddingRight: `${MAIN_GUTTER_MD_PX}px`,
  },
}));
